export const formatFullName = (
  user?: {
    firstName: string;
    lastName: string;
    email?: string;
  } | null,
) => {
  if (!user) {
    return "-";
  }

  if (!user.firstName && !user.lastName) {
    return user.email ?? "-";
  }

  return `${user.firstName} ${user.lastName}`;
};
